import { render, staticRenderFns } from "./chatMap.vue?vue&type=template&id=0b7d2001&scoped=true&"
import script from "./chatMap.vue?vue&type=script&lang=js&"
export * from "./chatMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7d2001",
  null
  
)

export default component.exports